import { captureOnboardingLaunch, hasOnboardingLaunchCredentials } from './lib/onboardingSession';

captureOnboardingLaunch();
// App/WebView reuse can deliver a new fragment to the already-open document.
const captureNavigation = (event: Event) => {
  const captured = captureOnboardingLaunch();
  const credentialEvent = event instanceof HashChangeEvent && [event.oldURL, event.newURL].some(hasOnboardingLaunchCredentials);
  if (captured || credentialEvent) event.stopImmediatePropagation();
  if (!captured) return;
  void import('./routes/routes').then(({ router }) =>
    router.navigate(window.location.pathname + window.location.search, { replace: true })
  );
};
window.addEventListener('popstate', captureNavigation);
window.addEventListener('hashchange', captureNavigation);
void import('./index');
